export const getUtmSource = () => window.location.host;
